/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 9 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { onSnapshot, collection, doc, setDoc, addDoc, query, orderBy, getDoc, getDocs } from 'firebase/firestore';
import { db } from '../../Firebase/firebase';
import { showToast } from '../../showTost';
import { useTranslation } from 'react-i18next';
import dayjs from "dayjs";
const Chat = ({ index, storeid, setShowChatList }) => {

    const { t } = useTranslation();
    const { ImgBasUrl, OneSignalStoreAppId, OneSignalUserKey } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [chatuser, setChatUser] = useState([]);
    const [searchdata, setSearchData] = useState([]);
    const [selectuser, setSelectUser] = useState(null);
    const [chatlist, setChatList] = useState([]);
    const [search, setSearch] = useState("");
    const [isshow, setIsShow] = useState(false);
    const [message, setMessage] = useState("");
    const [mychatid, setMyChatId] = useState([]);
    const [mychatlastmsg, setMyChatLastMsg] = useState([]);
    const [sendmsglod, setSendMsgLod] = useState(false);

    const Userid = secureLocalStorage.getItem("Userid");
    const chatBoxBodyRef = useRef(null);
    const selectedUserRef = useRef(null);
    const unsubscribeChatRef = useRef(null);

    const handleSelectUser = (item) => {
        setIsShow(true);
        setSelectUser(item);
        selectedUserRef.current = item;
        handleGetAllChat(item);
    };

    useEffect(() => {
        UserGetHandler();
        HandleGetMyChatUser();
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if (chatBoxBodyRef.current) {
                chatBoxBodyRef.current.scrollTop = chatBoxBodyRef.current.scrollHeight;
            }
        }, 500);
    }, [chatlist]);

    const UserGetHandler = () => {
        if (Userid) {
            const usersCollection = collection(db, "GoMechStore");
            const unsubscribe = onSnapshot(usersCollection, (snapshot) => {
                const users = snapshot.docs.map((doc) => doc.data());
                setChatUser(users);
                setSearchData(users);
                if (index === 0) {
                    const selectUserData = users.find(item => item.uid === storeid);
                    setSelectUser(selectUserData);
                    selectedUserRef.current = selectUserData;
                    handleGetAllChat(selectUserData);
                }
            });
            return () => unsubscribe();
        }
    };

    const HandleGetMyChatUser = () => {
        if (!Userid) return;

        const usersCollection = collection(db, 'GoMechChat');

        const fetchLastMessage = async (chatId) => {
            const [id1, id2] = chatId.split("_");

            const otherId = id1 === Userid ? id2 : null;

            if (!otherId) return null;

            const messagesRef = collection(db, "GoMechChat", chatId, "message");
            const messagesQuery = query(messagesRef, orderBy("timestamp", "asc"));
            const snapshot = await getDocs(messagesQuery);
            const messages = snapshot.docs.map(doc => doc.data());

            if (messages.length === 0) return null;

            const lastMessage = messages[messages.length - 1];
            const messageTime = lastMessage.timestamp?.toDate();

            if (!messageTime) return null;

            let hours = messageTime.getHours();
            const minutes = messageTime.getMinutes();
            const period = hours >= 12 ? 'PM' : 'AM';

            hours = hours % 12 || 12;
            const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes} ${period}`;

            return {
                uid: otherId,
                lastMessage: lastMessage.message,
                timestamp: formattedTime,
                sortchat: lastMessage.timestamp
            };
        };

        const unsubscribe = onSnapshot(usersCollection, async (snapshot) => {
            const ids = [];
            const lastmsg = [];

            const fetches = snapshot.docs.map(async (doc) => {
                const userData = await fetchLastMessage(doc.id);
                if (userData) {
                    ids.push(userData.uid);
                    lastmsg.push(userData);
                }
            });
            await Promise.all(fetches);
            setMyChatId(ids);
            setMyChatLastMsg(lastmsg);
        });

        return () => unsubscribe();
    };

    useEffect(() => {
        const result = mychatlastmsg.map(item => {
            const matchuser = chatuser.find(user => user.uid === item.uid);
            if (matchuser) {
                return {
                    ...item,
                    name: matchuser.name,
                    pro_pic: matchuser.pro_pic
                };
            }
            return item;
        });

        const FilterUser = result.sort((a, b) => {
            if (b.sortchat.seconds !== a.sortchat.seconds) {
                return b.sortchat.seconds - a.sortchat.seconds;
            }
            return b.sortchat.nanoseconds - a.sortchat.nanoseconds;
        });

        setChatUser(FilterUser);

        if (index !== 0 && !selectedUserRef.current && FilterUser.length > 0) {
            const firstUser = FilterUser[0];
            setSelectUser(firstUser);
            selectedUserRef.current = firstUser;
            handleGetAllChat(firstUser);
        }

        setTimeout(() => {
            setLoading(false);
        }, 500);

    }, [mychatlastmsg]);

    const handleSendMessage = async () => {

        if (sendmsglod) return;

        if (!selectuser) {
            showToast({ title: t("Please select user !!"), id: "error" });
            return;
        }

        if (!message.trim()) {
            showToast({ title: t("Please write message !!"), id: "error" });
            return;
        }

        setSendMsgLod(true);

        const LocalData = secureLocalStorage.getItem("LoginData");
        const { name } = JSON.parse(LocalData);
        const chatRoomId = [Userid, selectuser.uid].join("_");
        const userRef = doc(db, "GoMechChat", chatRoomId);

        const docSnapshot = await getDoc(userRef);
        const messageData = {
            message,
            reciverId: selectuser.uid,
            senderName: name,
            senderid: Userid,
            timestamp: new Date(),
        };

        if (docSnapshot.exists()) {
            await addDoc(collection(userRef, "message"), messageData);
        } else {
            await setDoc(userRef, { timestamp: new Date() });
            await addDoc(collection(userRef, "message"), messageData);
        }

        setMessage('');
        handleSendNotification(name, message, selectuser.uid);
        HandleGetMyChatUser();
        setSendMsgLod(false);
    };

    const handleGetAllChat = (storeuser) => {

        if (!Userid || !storeuser) return;

        const chatRoomId = [Userid, storeuser.uid].join("_");

        if (unsubscribeChatRef.current) {
            unsubscribeChatRef.current();
        }

        const messagesRef = collection(db, "GoMechChat", chatRoomId, "message");
        const messagesQuery = query(messagesRef, orderBy("timestamp", "asc"));

        const unsubscribe = onSnapshot(messagesQuery, (snapshot) => {
            if (selectedUserRef.current?.uid !== storeuser.uid) return;
            const data = snapshot.docs.map((doc) => {
                const messageData = doc.data();
                const messageTime = messageData.timestamp?.toDate();
                return {
                    ...messageData,
                    formattedTime: messageTime
                };
            });
            setChatList(data);
            HandleGetMyChatUser();
        });

        unsubscribeChatRef.current = unsubscribe;
    };

    const handleSendNotification = async (name, message, value) => {
        if (Notification.permission === "granted") {
            try {
                await axios.post('https://onesignal.com/api/v1/notifications', {
                    app_id: OneSignalStoreAppId,
                    filters: [{ field: 'tag', key: 'storeid', value }],
                    headings: { en: name },
                    contents: { en: message }
                }, {
                    headers: {
                        Authorization: OneSignalUserKey,
                    },
                });

            } catch (error) {
                console.error("Notification error:", error);
            }
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            handleSendMessage();
        }
    };

    useEffect(() => {
        const searchResults = chatuser.filter((item) =>
            item.name.toLowerCase().includes(search.toLowerCase())
        );
        setSearchData(search ? searchResults : chatuser);
    }, [search, chatuser]);

    const handleTimeFormat = (messageTime) => {
        if (!messageTime) return "No time available";

        const now = new Date();
        const msgDate = new Date(messageTime);
        const isToday = now.toDateString() === msgDate.toDateString();
        const isYesterday = new Date(now.setDate(now.getDate() - 1)).toDateString() === msgDate.toDateString();

        const timeStr = msgDate.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });

        if (isToday) return `Today ${timeStr}`;
        if (isYesterday) return `Yesterday ${timeStr}`;
        return `${msgDate.toLocaleString('en-US', { weekday: 'long' })} ${timeStr}`;
    };

    return (
        <div className="">
            {index === 0
                ? <div className="mini_chat border-[1px] rounded-[10px]">
                    <div className="border-b-[1px] py-[5px] px-[10px]">
                        <div className="flex items-center gap-[10px]">
                            <button onClick={() => setShowChatList(false)}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
                                </svg>
                            </button>
                            <img src={ImgBasUrl + selectuser?.pro_pic} className='w-[50px] h-[50px] rounded-full object-cover border-[1px]' alt="" />
                            <h1 className='font-[500] text-[18px]'>{selectuser?.name}</h1>
                        </div>
                    </div>

                    <div ref={chatBoxBodyRef} className="h-[500px] px-[5px] scroll-container">
                        <ul className='h-full'>
                            {chatlist.length >= 1
                                ? chatlist.map((item, index) => {
                                    const ItsMe = item.senderid === Userid && (item.reciverId === Userid ? (item.senderName !== selectuser?.name && true) : true)
                                    return <li key={index} className={`${ItsMe ? "msg_out" : "msg_in"}`}>
                                        <div className={`${ItsMe ? "text-end" : "text-start"}`}>
                                            <h1 className="msg_text m-0">{item.message}</h1>
                                            <br />
                                            <span className="text-[13px]">{handleTimeFormat(item.formattedTime)}</span>
                                        </div>
                                    </li>
                                })
                                : <div className="h-full w-full flex items-center justify-center">
                                    <h1 className='font-[500] text-[18px] text-gray-500'>{t("Chat list not found !!")}</h1>
                                </div>
                            }
                        </ul>
                    </div>

                    <div className="border-t-[1px] p-[10px]">
                        <div className="flex items-center gap-[10px]">
                            <input type="text" value={message} onKeyDown={handleKeyPress} onChange={(e) => setMessage(e.target.value)} className='w-full border-[1px] p-[5px] rounded-[5px] focus-within:outline-[#682afb]' placeholder={t('Write message here...')} />
                            <button onClick={handleSendMessage} className='bg-[#682afb] px-[10px] py-[5px] rounded-[10px]'>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.447 3.06298L5.33394 6.34099C2.20094 7.12399 2.23193 11.588 5.37593 12.328L9.45503 13.288C9.55603 13.312 9.66303 13.282 9.73603 13.208L14.4741 8.46999C14.7641 8.17999 15.2439 8.17999 15.5339 8.46999C15.8239 8.75999 15.8239 9.23999 15.5339 9.52999L10.7939 14.27C10.7209 14.343 10.6901 14.45 10.7141 14.551L11.673 18.626C12.413 21.77 16.8769 21.801 17.6599 18.668L20.9379 5.55498C21.3129 4.04898 19.95 2.68698 18.447 3.06298Z" fill="white" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                : <div className="">
                    {loading
                        ? <div className="w-full h-[100vh] bg-white fixed top-0 flex items-center justify-center">
                            <div className="loader2"></div>
                        </div>
                        : <div className='chat_page'>

                            <div className={`h-[calc(100vh-100px)] w-full p-[10px] flex items-start justify-center gap-[20px] overflow-hidden ${isshow ? "open" : ""}`}>
                                <div className="chat_user">
                                    <div className="border-[2px] border-gray-300 focus-within:border-[#682afb] rounded-[10px] py-[8px] px-[10px]">
                                        <div className="flex items-center">
                                            <input type="text" value={search} onChange={(e) => setSearch(e.target.value)} className='w-full outline-none' placeholder='Search User' />
                                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21.53 20.47L17.689 16.629C18.973 15.106 19.75 13.143 19.75 11C19.75 6.175 15.825 2.25 11 2.25C6.175 2.25 2.25 6.175 2.25 11C2.25 15.825 6.175 19.75 11 19.75C13.143 19.75 15.106 18.973 16.629 17.689L20.47 21.53C20.616 21.676 20.808 21.75 21 21.75C21.192 21.75 21.384 21.677 21.53 21.53C21.823 21.238 21.823 20.763 21.53 20.47ZM3.75 11C3.75 7.002 7.002 3.75 11 3.75C14.998 3.75 18.25 7.002 18.25 11C18.25 14.998 14.998 18.25 11 18.25C7.002 18.25 3.75 14.998 3.75 11Z" fill="#25314C" />
                                            </svg>
                                        </div>
                                    </div>

                                    <div className="mt-[10px] scroll-container h-[calc(100%-50px)]">
                                        {searchdata.length >= 1
                                            ? searchdata?.map((item, index) => {
                                                if (mychatid.includes(item.uid)) {
                                                    return <div key={index} onClick={() => handleSelectUser(item)} className={`border-[2px] ${item.uid === selectuser?.uid && "border-[#682afb]"} mt-[10px] p-[10px] rounded-[10px] cursor-pointer`}>
                                                        <div className="flex items-center justify-between gap-[10px]">
                                                            <div className="flex items-center gap-[10px] overflow-hidden">
                                                                <div className={`${item.pro_pic === "null" && "bg-gray-200 flex items-center justify-center border-[#682afb]"} border-[1px] min-w-[50px] w-[50px] h-[50px] rounded-full overflow-hidden`}>
                                                                    {item.pro_pic !== "null"
                                                                        ? <img src={ImgBasUrl + item.pro_pic} className='w-full h-full object-cover' alt="pro_pic" />
                                                                        : <h1 className='font-bold text-[18px] text-[#682afb]'>{item.name.slice(0, 1).toUpperCase()}</h1>}
                                                                </div>
                                                                <div className="overflow-hidden">
                                                                    <h1 className='font-[500] text-[16px] whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.name}</h1>
                                                                    <p className='whitespace-nowrap overflow-hidden text-gray-600 overflow-ellipsis'>{item.lastMessage}</p>
                                                                </div>
                                                            </div>
                                                            <span className='font-[500] text-[14px] text-gray-600 text-center'>{item.timestamp}</span>
                                                        </div>
                                                    </div>
                                                }
                                            })
                                            : <div className="h-full w-full flex items-center justify-center">
                                                <h1 className='font-[500] text-[18px] text-gray-500'>{t("User not found !!")}</h1>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="chat_list">
                                    <div className="flex flex-col h-full w-full">
                                        <div className="w-full bg-white py-[10px] px-[20px] rounded-[10px]">
                                            {!selectuser
                                                ? <h1 className='font-[500] text-[18px]'>{t("Select user")}</h1>
                                                : <div className="flex items-center gap-[10px]">
                                                    <button onClick={() => { setIsShow(false); setSelectUser(""); setChatList([]) }} className='max-_770_:block hidden'>
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M15 19.75C14.808 19.75 14.616 19.6771 14.47 19.5301L7.46999 12.5301C7.17699 12.2371 7.17699 11.762 7.46999 11.469L14.47 4.46902C14.763 4.17602 15.238 4.17602 15.531 4.46902C15.824 4.76202 15.824 5.23705 15.531 5.53005L9.06106 12L15.531 18.47C15.824 18.763 15.824 19.238 15.531 19.531C15.384 19.677 15.192 19.75 15 19.75Z" fill="#25314C" />
                                                        </svg>
                                                    </button>
                                                    <div className={`${selectuser?.pro_pic === "null" && "bg-gray-200 flex items-center justify-center border-[#682afb]"} border-[1px] w-[50px] h-[50px] rounded-full overflow-hidden`}>
                                                        {selectuser?.pro_pic !== "null"
                                                            ? <img src={ImgBasUrl + selectuser?.pro_pic} className='w-full h-full object-cover' alt="user_img" />
                                                            : <h1 className='font-bold text-[18px] text-[#682afb]'>{selectuser?.name?.slice(0, 1).toUpperCase()}</h1>}
                                                    </div>
                                                    <h1 className='font-[500] text-[17px]'>{selectuser?.name}</h1>
                                                </div>}
                                        </div>

                                        <div ref={chatBoxBodyRef} className="chat_body h-full w-full my-[10px] rounded-[10px] scroll-container">
                                            <ul className='h-full'>
                                                {chatlist.length >= 1
                                                    ? chatlist?.map((item, index) => {
                                                        return <ChatList item={item} index={index} Userid={Userid} selectuser={selectuser} chatlist={chatlist} handleTimeFormat={handleTimeFormat} />
                                                    })
                                                    : <div className="h-full w-full flex items-center justify-center">
                                                        <h1 className='font-[500] text-[18px] text-gray-500'>{t("Chat list not found !!")}</h1>
                                                    </div>}
                                            </ul>
                                        </div>

                                        <div className="w-full bg-white p-[15px] rounded-[10px]">
                                            <div className="flex items-center gap-[20px]">
                                                <input value={message} onKeyDown={handleKeyPress} onChange={(e) => setMessage(e.target.value)} type="text" className='w-full outline-none border-[2px] rounded-[10px] p-[13px] focus-within:border-[#682afb] font-[500]' placeholder={t('Write message here...')} />
                                                <button onClick={handleSendMessage} className='bg-[#682afb] py-[10px] px-[15px] rounded-[10px]'>
                                                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M18.447 3.06298L5.33394 6.34099C2.20094 7.12399 2.23193 11.588 5.37593 12.328L9.45503 13.288C9.55603 13.312 9.66303 13.282 9.73603 13.208L14.4741 8.46999C14.7641 8.17999 15.2439 8.17999 15.5339 8.46999C15.8239 8.75999 15.8239 9.23999 15.5339 9.52999L10.7939 14.27C10.7209 14.343 10.6901 14.45 10.7141 14.551L11.673 18.626C12.413 21.77 16.8769 21.801 17.6599 18.668L20.9379 5.55498C21.3129 4.04898 19.95 2.68698 18.447 3.06298Z" fill="white" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>}
                </div>}

        </div>
    )
}

export default Chat
/* jshint ignore:end */

const ChatList = ({ item, index, Userid, selectuser, chatlist, handleTimeFormat }) => {

    const ItsMe =
        item.senderid === Userid &&
        (item.reciverId === Userid
            ? item.senderName !== selectuser?.name
            : true);

    const msgDate = dayjs(item.timestamp?.toDate()).format("YYYY-MM-DD");

    let prevDate = null;
    if (index > 0) {
        prevDate = dayjs(chatlist[index - 1].timestamp?.toDate()).format("YYYY-MM-DD");
    }

    const showDateHeader = msgDate !== prevDate;

    const today = dayjs().format("YYYY-MM-DD");
    const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

    let dateLabel = "";
    if (msgDate === today) dateLabel = "Today";
    else if (msgDate === yesterday) dateLabel = "Yesterday";
    else dateLabel = dayjs(item.timestamp?.toDate()).format("D MMM YYYY");

    return (
        <div key={index}>
            {showDateHeader && (
                <div className="date_header text-center text-gray-500 my-3 font-medium text-[14px]">
                    {dateLabel}
                </div>
            )}
            <li className={`${ItsMe ? "msg_out" : "msg_in"}`}>
                <div className={`${ItsMe ? "text-end" : "text-start"}`}>
                    <h1 className="msg_text m-0">{item.message}</h1>
                    <br />
                    <span className="text-[13px]">{handleTimeFormat(item.formattedTime)}</span>
                </div>
            </li>
        </div>
    );
}